import { render, staticRenderFns } from "./StAlert.vue?vue&type=template&id=31ee0b21&scoped=true"
import script from "./StAlert.vue?vue&type=script&lang=js"
export * from "./StAlert.vue?vue&type=script&lang=js"
import style0 from "./StAlert.vue?vue&type=style&index=0&id=31ee0b21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ee0b21",
  null
  
)

export default component.exports